import { render, staticRenderFns } from "./RatioOut.vue?vue&type=template&id=53493794&scoped=true"
import script from "./RatioOut.vue?vue&type=script&lang=js"
export * from "./RatioOut.vue?vue&type=script&lang=js"
import style0 from "./RatioOut.vue?vue&type=style&index=0&id=53493794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53493794",
  null
  
)

export default component.exports